import type { JSONB } from '@risksmart-app/domain/src/types/common.types';
import { customAttributeDataSchema } from '@risksmart-app/domain/src/types/common.types';

import type {
  DistributiveOmit,
  FrontendRouterInputs,
} from '@/hooks/mutations/routerInputs';

type NativeInput = FrontendRouterInputs['documentFile']['update'];

export type UpdateDocumentVersionInput = DistributiveOmit<
  NativeInput,
  '_confirmChangeRequest' | '_requesterComment' | 'CustomAttributeData'
> & { CustomAttributeData?: JSONB | null };

/** Validate stored custom fields only when entering the native mutation leg. */
export const toNativeDocumentVersionPayload = (
  input: UpdateDocumentVersionInput
): NativeInput => ({
  ...input,
  CustomAttributeData:
    input.CustomAttributeData == null
      ? input.CustomAttributeData
      : customAttributeDataSchema.parse(input.CustomAttributeData),
});
